import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import CloudDownloadTwoTone from "@material-ui/icons/CloudDownloadTwoTone"
import { obtenrWalletDocumento } from "./../../../../ducks/viajeCalendarioDuck"
import { useState } from "react"
import { ToastMessage } from "../../../../global/ToastMessage"
import BackDrop from "../../../../global/BackDrop"
const ButtonDoload = (props) => {
    const { idDocumento } = props
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const onDowload = () => {
        setLoad(true)
        dispatch(obtenrWalletDocumento({ idDocumento: idDocumento })).then(Response => {
            if (Response.status || Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                setLoad(false)
                return null
            }

            const downloadUrl = window.URL.createObjectURL(new Blob([Response], { type: "application/pdf" }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            // let fchAct = new Date().toISOString();
            // let fileName =  `${Nombre} - ${fchAct}.pdf`;
            // link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoad(false)
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={onDowload} >
                <CloudDownloadTwoTone color="primary" />
            </IconButton>
            <BackDrop open={load} />
        </div>

    )
}
export default ButtonDoload